import { StateUtils } from '@spartacus/core';

export const REFERENCE_FEATURE = 'Reference';

export const REFERENCE = 'Reference';

export const RR_CART_REC = '[Reference[RR]] Cart Recomendation';

export const RR_REC = '[Reference[RR]]  Recomendation';

export interface RetailRocketState {
  recomendationList: StateUtils.EntityLoaderState<number[]>;
}

export interface ReferenceState {
  RR: RetailRocketState;
}

export interface StateWithReference {
  [REFERENCE_FEATURE]: ReferenceState;
}
